import * as toastify from "react-toastify"
import {
  faCheck,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const showMasterRegisterToast = (message: string) =>
  toastify.toast.dark(
    <>
      <FontAwesomeIcon
        icon={faCheck}
        style={{
          color: "#00FF00",
          marginRight: "1rem",
        }}></FontAwesomeIcon>
      <span>{message}</span>
    </>,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: toastify.Slide,
    }
  )

export const showInfoToast = (message: string | string[]) =>
  toastify.toast.info(
    <>
      <FontAwesomeIcon
        icon={faCheck}
        style={{
          color: "#00FF00",
          marginRight: "1rem",
        }}></FontAwesomeIcon>
      {typeof message === "string" && <span>{message}</span>}
      {typeof message !== "string" &&
        (message as string[]).map((m, i) => {
          return i === 0 ? <span key={i}>{m}</span> : <p key={i}>{m}</p>
        })}
    </>,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: toastify.Slide,
    }
  )

export const showWarningToast = (
  message: string | string[],
  closeTime?: number | false
) =>
  toastify.toast.info(
    <>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        style={{
          color: "#ffc107",
          marginRight: "1rem",
        }}></FontAwesomeIcon>
      {typeof message === "string" && <span>{message}</span>}
      {typeof message !== "string" &&
        (message as string[]).map((m, i) => {
          return i === 0 ? <span key={i}>{m}</span> : <p key={i}>{m}</p>
        })}
    </>,
    {
      position: "top-right",
      autoClose: closeTime != null ? closeTime : 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: toastify.Slide,
    }
  )
